"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useState, useEffect, useMemo } from "react";
import { Tooltip } from "react-tooltip";
import { ApiWaveDecisionWinner } from "@/generated/models/ApiWaveDecisionWinner";
import { ApiWaveOutcomeCredit } from "@/generated/models/ApiWaveOutcomeCredit";
import { ApiWaveOutcomeType } from "@/generated/models/ApiWaveOutcomeType";
import { formatNumberWithCommas } from "@/helpers/Helpers";
import { OutcomeType } from "@/hooks/drops/useDropOutcomes";
interface WavePodiumItemContentOutcomesProps {
  readonly winner: ApiWaveDecisionWinner;
}
export const WavePodiumItemContentOutcomes: React.FC<WavePodiumItemContentOutcomesProps> = t0 => {
  const $ = _c(51);
  const {
    winner
  } = t0;
  const [isTouch, setIsTouch] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      setIsTouch("ontouchstart" in window);
    };
    t2 = [];
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  useEffect(t1, t2);
  let t3;
  if ($[2] !== isOpen || $[3] !== isTouch) {
    t3 = e => {
      if (isTouch) {
        e.stopPropagation();
        setIsOpen(!isOpen);
      }
    };
    $[2] = isOpen;
    $[3] = isTouch;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const handleClick = t3;
  let t4;
  if ($[5] !== winner.awards) {
    t4 = winner.awards.filter(_temp).map(_temp2);
    $[5] = winner.awards;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const nicOutcomes = t4;
  let t5;
  if ($[7] !== winner.awards) {
    t5 = winner.awards.filter(_temp3).map(_temp4);
    $[7] = winner.awards;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const repOutcomes = t5;
  let t6;
  if ($[9] !== winner.awards) {
    t6 = winner.awards.filter(_temp5).map(_temp6);
    $[9] = winner.awards;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  const manualOutcomes = t6;
  const haveOutcomes = !!nicOutcomes.length || !!repOutcomes.length || !!manualOutcomes.length;
  let t7;
  if ($[11] !== haveOutcomes || $[12] !== manualOutcomes || $[13] !== nicOutcomes || $[14] !== repOutcomes) {
    t7 = {
      nicOutcomes,
      repOutcomes,
      manualOutcomes,
      haveOutcomes
    };
    $[11] = haveOutcomes;
    $[12] = manualOutcomes;
    $[13] = nicOutcomes;
    $[14] = repOutcomes;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  const {
    nicOutcomes: nicOutcomes_0,
    repOutcomes: repOutcomes_0,
    manualOutcomes: manualOutcomes_0,
    haveOutcomes: haveOutcomes_0
  } = t7;
  if (!haveOutcomes_0) {
    return null;
  }
  let t8;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <span className="tw-text-xs tw-font-medium tw-text-iron-400">Outcome Details</span>;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== nicOutcomes_0) {
    t9 = nicOutcomes_0.map(_temp7);
    $[17] = nicOutcomes_0;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== repOutcomes_0) {
    t10 = repOutcomes_0.map(_temp8);
    $[19] = repOutcomes_0;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== manualOutcomes_0) {
    t11 = manualOutcomes_0.map(_temp9);
    $[21] = manualOutcomes_0;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== t10 || $[24] !== t11 || $[25] !== t9) {
    t12 = <div className="tw-p-3.5 tw-space-y-3 lg:tw-min-w-[220px] tw-backdrop-blur-xl tw-bg-iron-900/95 tw-border tw-border-iron-800/60 tw-rounded-xl tw-shadow-[0_8px_32px_rgba(0,0,0,0.35)]"><div className="tw-space-y-2.5">{t8}<div className="tw-space-y-2">{t9}{t10}{t11}</div></div></div>;
    $[23] = t10;
    $[24] = t11;
    $[25] = t9;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  const tooltipContent = t12;
  let t13;
  if ($[27] !== handleClick) {
    t13 = e_0 => {
      e_0.preventDefault();
      e_0.stopPropagation();
      handleClick(e_0);
    };
    $[27] = handleClick;
    $[28] = t13;
  } else {
    t13 = $[28];
  }
  const t14 = `outcome-${winner.place}-${winner.drop.id}`;
  let t15;
  if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <span className="tw-text-sm tw-font-medium tw-text-iron-300 tw-hidden md:tw-block">Outcome</span>;
    $[29] = t15;
  } else {
    t15 = $[29];
  }
  let t16;
  if ($[30] !== nicOutcomes_0.length) {
    t16 = !!nicOutcomes_0.length && <div className="tw-flex tw-items-center tw-justify-center tw-size-5 tw-rounded-full tw-bg-[#A4C2DB]/10"><svg className="tw-size-3.5 tw-text-[#A4C2DB]" viewBox="0 0 24 24" aria-hidden="true" fill="none"><path d="M9 6.75H15M9 12H15M9 17.25H12M3.75 19.5H20.25C21.0784 19.5 21.75 18.8284 21.75 18V6C21.75 5.17157 21.0784 4.5 20.25 4.5H3.75C2.92157 4.5 2.25 5.17157 2.25 6V18C2.25 18.8284 2.92157 19.5 3.75 19.5Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" /></svg></div>;
    $[30] = nicOutcomes_0.length;
    $[31] = t16;
  } else {
    t16 = $[31];
  }
  let t17;
  if ($[32] !== repOutcomes_0.length) {
    t17 = !!repOutcomes_0.length && <div className="tw-flex tw-items-center tw-justify-center tw-size-5 tw-rounded-full tw-bg-[#C3B5D9]/10"><svg className="tw-size-3.5 tw-text-[#C3B5D9]" viewBox="0 0 24 24" aria-hidden="true" fill="none"><path d="M11.48 3.499a.562.562 0 011.04 0l2.125 5.111a.563.563 0 00.475.345l5.518.442c.499.04.701.663.321.988l-4.204 3.602a.563.563 0 00-.182.557l1.285 5.385a.562.562 0 01-.84.61l-4.725-2.885a.563.563 0 00-.586 0L6.982 20.54a.562.562 0 01-.84-.61l1.285-5.386a.562.562 0 00-.182-.557l-4.204-3.602a.563.563 0 01.321-.988l5.518-.442a.563.563 0 00.475-.345L11.48 3.5z" stroke="currentColor" strokeWidth="1.5" /></svg></div>;
    $[32] = repOutcomes_0.length;
    $[33] = t17;
  } else {
    t17 = $[33];
  }
  let t18;
  if ($[34] !== manualOutcomes_0.length) {
    t18 = !!manualOutcomes_0.length && <div className="tw-flex tw-items-center tw-justify-center tw-size-5 tw-rounded-full tw-bg-[#D4C5AA]/10"><svg className="tw-size-3.5 tw-text-[#D4C5AA]" viewBox="0 0 24 24" aria-hidden="true" fill="none"><path d="M12 18v-3m0-3v.01M12.75 3.25h-1.5L8.5 7H4.75l.5 3.5L2 13l3.25 2.5-.5 3.5h3.75l2.75 3.75h1.5L15.5 19h3.75l-.5-3.5L22 13l-3.25-2.5.5-3.5H15.5l-2.75-3.75z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" /></svg></div>;
    $[34] = manualOutcomes_0.length;
    $[35] = t18;
  } else {
    t18 = $[35];
  }
  let t19;
  if ($[36] !== t16 || $[37] !== t17 || $[38] !== t18) {
    t19 = <div className="tw-flex tw-items-center tw-gap-1.5">{t16}{t17}{t18}</div>;
    $[36] = t16;
    $[37] = t17;
    $[38] = t18;
    $[39] = t19;
  } else {
    t19 = $[39];
  }
  let t20;
  if ($[40] !== t13 || $[41] !== t14 || $[42] !== t19) {
    t20 = <button onClick={t13} className="tw-transition-all tw-duration-200 tw-flex tw-items-center tw-gap-2 tw-px-3 tw-py-1.5 tw-rounded-xl tw-bg-iron-800/40 tw-backdrop-blur-sm tw-border tw-border-solid tw-border-iron-700/20 hover:tw-bg-iron-800/60 hover:tw-border-iron-700/40 hover:tw-shadow-lg" data-tooltip-id={t14}>{t15}{t19}</button>;
    $[40] = t13;
    $[41] = t14;
    $[42] = t19;
    $[43] = t20;
  } else {
    t20 = $[43];
  }
  const t21 = `outcome-${winner.place}-${winner.drop.id}`;
  let t22;
  if ($[44] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = {
      backgroundColor: "#1F2937",
      color: "white",
      padding: "4px 8px"
    };
    $[44] = t22;
  } else {
    t22 = $[44];
  }
  let t23;
  if ($[45] !== t21 || $[46] !== tooltipContent) {
    t23 = <Tooltip id={t21} place="left" delayShow={200} style={t22}>{tooltipContent}</Tooltip>;
    $[45] = t21;
    $[46] = tooltipContent;
    $[47] = t23;
  } else {
    t23 = $[47];
  }
  let t24;
  if ($[48] !== t20 || $[49] !== t23) {
    t24 = <>{t20}{t23}</>;
    $[48] = t20;
    $[49] = t23;
    $[50] = t24;
  } else {
    t24 = $[50];
  }
  return t24;
};
function _temp(award) {
  return award.credit === ApiWaveOutcomeCredit.Cic && award.amount && award.amount > 0;
}
function _temp2(award_0) {
  return {
    type: OutcomeType.NIC as const,
    value: award_0.amount || 0
  };
}
function _temp3(award_1) {
  return award_1.credit === ApiWaveOutcomeCredit.Rep && award_1.amount && award_1.amount > 0;
}
function _temp4(award_2) {
  return {
    type: OutcomeType.REP as const,
    value: award_2.amount ?? 0,
    category: award_2.rep_category ?? ""
  };
}
function _temp5(award_3) {
  return award_3.type === ApiWaveOutcomeType.Manual && award_3.description;
}
function _temp6(award_4) {
  return {
    type: OutcomeType.MANUAL as const,
    description: award_4.description
  };
}
function _temp7(nicOutcome) {
  return <div key={`NIC-${nicOutcome.value}`} className="tw-flex tw-items-center tw-justify-between tw-p-2 tw-rounded-lg tw-bg-iron-800/40"><div className="tw-flex tw-items-center tw-gap-2"><svg className="tw-size-4 tw-text-[#A4C2DB] tw-flex-shrink-0" viewBox="0 0 24 24" aria-hidden="true" fill="none"><path d="M9 6.75H15M9 12H15M9 17.25H12M3.75 19.5H20.25C21.0784 19.5 21.75 18.8284 21.75 18V6C21.75 5.17157 21.0784 4.5 20.25 4.5H3.75C2.92157 4.5 2.25 5.17157 2.25 6V18C2.25 18.8284 2.92157 19.5 3.75 19.5Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" /></svg><span className="tw-text-sm tw-font-medium tw-text-iron-200">NIC</span></div><span className="tw-text-sm tw-font-semibold tw-text-[#A4C2DB]">{formatNumberWithCommas(nicOutcome.value)}</span></div>;
}
function _temp8(repOutcome) {
  return <div key={`REP-${repOutcome.category}-${repOutcome.value}`} className="tw-p-2 tw-flex tw-flex-col tw-gap-y-1 tw-rounded-lg tw-bg-iron-800/40"><div className="tw-flex tw-items-center tw-justify-between"><div className="tw-flex tw-items-center tw-gap-2"><svg className="tw-size-4 tw-text-[#C3B5D9] tw-flex-shrink-0" viewBox="0 0 24 24" aria-hidden="true" fill="none"><path d="M11.48 3.499a.562.562 0 011.04 0l2.125 5.111a.563.563 0 00.475.345l5.518.442c.499.04.701.663.321.988l-4.204 3.602a.563.563 0 00-.182.557l1.285 5.385a.562.562 0 01-.84.61l-4.725-2.885a.563.563 0 00-.586 0L6.982 20.54a.562.562 0 01-.84-.61l1.285-5.386a.562.562 0 00-.182-.557l-4.204-3.602a.563.563 0 01.321-.988l5.518-.442a.563.563 0 00.475-.345L11.48 3.5z" stroke="currentColor" strokeWidth="1.5" /></svg><span className="tw-text-sm tw-font-medium tw-text-iron-200">Rep</span></div><span className="tw-text-sm tw-font-semibold tw-text-[#C3B5D9]">{formatNumberWithCommas(repOutcome.value)}</span></div><span className="tw-text-sm tw-font-semibold tw-text-[#C3B5D9]">{repOutcome.category}</span></div>;
}
function _temp9(outcome) {
  return <div key={`MANUAL-${outcome.description}`} className="tw-flex tw-items-center tw-justify-between tw-p-2 tw-rounded-lg tw-bg-iron-800/40"><div className="tw-flex tw-items-center tw-gap-2"><svg className="tw-size-4 tw-text-[#D4C5AA] tw-flex-shrink-0" viewBox="0 0 24 24" aria-hidden="true" fill="none"><path d="M12 18v-3m0-3v.01M12.75 3.25h-1.5L8.5 7H4.75l.5 3.5L2 13l3.25 2.5-.5 3.5h3.75l2.75 3.75h1.5L15.5 19h3.75l-.5-3.5L22 13l-3.25-2.5.5-3.5H15.5l-2.75-3.75z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" /></svg><span className="tw-text-sm tw-font-medium tw-text-iron-200">{outcome.description}</span></div></div>;
}